export const text = {
  active: "Active",
  disabled: "Disabled",
  update: "Update Order",
};
